<template>
  <div>
    <AddressList :addressList="addressList"></AddressList>
    <div class="text-center">
    <b-button  variant="success" class="" style="width: 50%; margin: 50px 0px; padding: 10px 0px; "  @click="$router.push('/cart/address/create')"><i class="pr-2  fa fa-plus"></i>{{$t('cart.address.create')}}</b-button>
  </div>
     <div class="mt-5" style="height: 50px; ">
      <b-button variant="success" class="footer-button" @click="$router.push('/account')">{{$t('kol.footer.goBackAccount')}}</b-button>
    </div>
  </div>
</template>
<script type="text/javascript">

import AddressList from '../components/AddressList' 
import Cookies from 'js-cookie'

// import GridContainer from '../components/GridContainer'

export default {
  name: 'Cart',
  components: {
    AddressList
  },
  props: {},
  data() {
    return {
    }
  },
  created() {
    document.title = this.$t('kol.footer.addressList');
    this.$store.commit("hideFooter", true);
    this.$store.dispatch('getUserAddress', {}).then((json) => {
      console.log(json);
      if(json.status == 401){
        Cookies.remove('token');
        this.$router.push('/login');
      }else{
        if(!this.$store.state.currentAddress){
          this.$store.commit('updateCurrentAddress', json.data.list[0]);
        }
        this.$store.commit('updateAddressList', json.data.list);
      }
    }).catch((err) => {
      console.error(err);
      if(err.status == 401 && Cookies.get('redirect') == 'true' && this.refresh == true){
        this.$router.go(0);
        this.$store.commit('forceRefresh',false);
      }
    });

  },
  mounted() {
  },
  watch: {},
  computed: {
    addressList(){
      return this.$store.state.addressList;
    },
    refresh(){
      return this.$store.state.refresh;
    }
  },
  methods: {

  },
}

</script>
<style type="text/css">

</style>





// WEBPACK FOOTER //
// src/Cart/containers/Address.vue